<template>
  <div>
    <span>Упражнение: {{mode.name}} Schreiben(Пишем)</span>
    <br />
    <span>
      <a class="indigo-text text-lighten-1">Задание : напишите на немецком перевод предложения</a>
    </span>    
                
    <div class="progress grey lighten-3">
      <div
        class="determinate indigo lighten-1"
        v-bind:style="{width: progressMode_erSatz_percent + '%'}"
      ></div>       
    </div>  
    
    <span class="right grey-text text-lighten-1" style="padding: 0px 10px 0px 0px">{{timerSeconds}}</span>
    
    <br />    
    <h6>{{satz.satzRU}}</h6>
    

    <a v-if="satz.tipp" class="indigo-text text-lighten-1">
      <small>Подсказка: {{satz.tipp}}</small>
    </a>

    <form @submit.prevent="next">
      <Loader v-if="loading" />

      <div v-else>
        <div v-if="satz.id && inputAnswerVisible" class="input-field">
          <textarea
            id="answerSatzDE"
            type="text"
            v-model.trim="answerSatzDE"
            class="materialize-textarea"
            v-bind:class="{invalid: $v.answerSatzDE.$dirty && !$v.answerSatzDE.required}"
          />
          <label for="answerSatzDE">Перевод на немецком</label>
          <span
            v-if="$v.answerSatzDE.$dirty && !$v.answerSatzDE.required"
            class="helper-text invalid"
          >Введите перевод на немецком</span>
        </div>

        <VerifyResult
          v-if="verifyResultVisible"
          v-bind:satzDeAnswer="answerSatzDE"
          v-bind:textMsg="textVerifyResult"
          v-bind:type="typeVerifyResult"
        />
      </div>

      <div>
        <div class="valign-wrapper section">
          <span style="padding: 0px 30px 0px 0px">
            <button
              class="waves-effect waves-light btn-flat btn-small indigo lighten-5"
              type="submit"
            >
              {{(satz.id==null) ? 'Начать' : 'ОК / ДАЛЕЕ'}}              
            </button>
          </span>

          <span v-if="satz.id" style="padding: 0px 0px 0px 0px">
            <a v-on:click.prevent="getTipp()">
              <a
                v-if="!playingSatz"
                class="waves-effect waves-light btn-flat btn-small indigo lighten-5"
              >                
                Подсказка
                <i class="material-icons right">volume_up</i>
              </a>
              <a
                v-else
                class="waves-effect waves-light btn-flat btn-small indigo lighten-5 red-text"
              >Звучит...</a>
            </a>
          </span>
        </div>        

      </div>
    </form>

    <a v-if="satz.id!=null" href="#modalMsgBottom" class="modal-trigger indigo-text text-lighten-2" style="padding: 0px 0px 0px 220px">Помощь?</a>

    <Tipp v-bind:idModeRegime="idModeRegime" v-if="tippVisible"/>
    
    <ModalMsgBottom v-model="modalMsgBottomCallFrom"/>    
  </div>
</template>

<style scoped>
.fontbold {
  font-weight: bold;
}
.fontbig {
  color: black;
  font-size: 150%;
}
</style>

<script>
import ModeRegimeMixin from '@/utils/mode_regime.mixin.js'
import ModeRegimeTimerMixin from '@/utils/mode_regime_timer.mixin.js'

import VerifyResult from "@/views/VerifyResult";
import Tipp from "@/views/Tipp";
import ModalMsgBottom from "@/views/MsgModalBottom";
import { required } from "vuelidate/lib/validators";

export default {
  name: "mode_regime_sch",
  mixins: [ModeRegimeMixin, ModeRegimeTimerMixin],
  components: {
    VerifyResult,
    Tipp,
    ModalMsgBottom      
  },
  mounted() {            
  },
  data: () => ({
    modalMsgBottomCallFrom:'mode_regime_sch',

    idModeRegime:'sch',

    loading: false,

    inputAnswerVisible: true,
    answerSatzDE: "",

    verifyResultVisible: false,
    textVerifyResult: "",
    typeVerifyResult: "",

    tippVisible: false, 

    playingSatz: false
  }),
  validations: {
    answerSatzDE: { required }
  },
  methods: {    
  },
};
</script>
